/* eslint-disable func-style */
import { yodaIdentityConstants } from "../constants";
import { yodaIdentityService } from "../services";
import { systemActions } from "./system.actions";

export const yodaIdentityActions = {
  getOne,
  getColors,
};

function getOne(uuid) {
  return (dispatch) => {
    dispatch(request());

    yodaIdentityService.getOne(uuid).then(
      (response) => {
        if (
          response.results !=
          null /* && response.results != undefined && response.results.length > 0 */
        ) {
          const { results } = response;
          dispatch(success(results));
          dispatch(systemActions.setUser(results[0]));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: yodaIdentityConstants.GET_ONE_REQUEST };
  }
  function success(identity) {
    return {
      type: yodaIdentityConstants.GET_ONE_SUCCESS,
      payload: { identity },
    };
  }
  function failure(error) {
    return { type: yodaIdentityConstants.GET_ONE_FAILURE, payload: { error } };
  }
}

function getColors() {
  return (dispatch) => {
    dispatch(request());

    yodaIdentityService.getColors().then(
      (response) => {
        if (
          response !=
          null /* && response.results != undefined && response.results.length > 0 */
        ) {
          dispatch(success(response));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: yodaIdentityConstants.GET_COLORS_REQUEST };
  }
  function success(colors) {
    return {
      type: yodaIdentityConstants.GET_COLORS_SUCCESS,
      payload: { colors },
    };
  }
  function failure(error) {
    return {
      type: yodaIdentityConstants.GET_COLORS_FAILURE,
      payload: { error },
    };
  }
}
